/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Radio,
  Row,
  Upload,
} from "antd";
import { AiOutlineUpload } from "react-icons/ai";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { axios, getToken, URL_API, _ } from "../../../../../utils";
import { Panel, PanelBody, PanelHeader } from "../../../../util/panel";
import { beforeUploadImg } from "../../../../util/helper/index";
import useUploadFile from "../../components/useUploadFile";
import { dummyRequest } from "../../components/dummyRequest";
import useAsync from "../../../../../utils/useAsync";
import manageWebsiteService from "../../../../../services/manage-website.service";
import { DivStyles, ImgStyles } from "../../components/mwStyles";

function BannerContent({ history, match, form, ...props }) {
  const [fileListDesktop, setFileListDesktop] = useState([]);
  const [fileListMobile, setFileListMobile] = useState([]);
  const [fileDelete, setFileDelete] = useState([]);

  let { onUpload, onRemoveUpload } = useUploadFile();

  const handleClickSubmit = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      }

      console.log({ values });

      let formData = new FormData();

      if (fileListDesktop[0]?.file) {
        formData.append("desktop_img", fileListDesktop[0]?.file?.originFileObj);
      }

      if (fileListMobile[0]?.file) {
        formData.append("mobile_img", fileListMobile[0]?.file?.originFileObj);
      }

      // if (values.desktop_img?.file?.originFileObj)
      //   formData.append("desktop_img", values.desktop_img?.file?.originFileObj);
      // if (values.mobile_img?.file?.originFileObj)
      //   formData.append("mobile_img", values.mobile_img?.file?.originFileObj);

      formData.append(
        "data",
        JSON.stringify({
          ..._.omit(values, ["desktop_img", "mobile_img"]),
          file_delete: fileDelete,
        })
      );

      Modal.confirm({
        title: "ยืนยัน",
        content: "ต้องการบันทึกข้อมูลหรือไม่",
        okText: "บันทึก",
        cancelText: "ปิด",
        onOk() {
          return new Promise((resolve, reject) => {
            let actionPathUrl;

            if (match.params.id !== "add") {
              actionPathUrl =
                "/manage-website/home/banner/" + match.params.id + "/update";
            } else {
              actionPathUrl = "/manage-website/home/banner";
            }

            axios({
              method: "post",
              baseURL: URL_API,
              url: actionPathUrl,
              headers: { Authorization: "Bearer " + getToken() },
              data: formData,
            })
              .then((res) => {
                console.log(res);
                resolve("success");
              })
              .catch((err) => {
                console.log(err);
                reject(
                  err && err.response
                    ? err.response.data.message
                      ? err.response.data.message
                      : err.response.data
                    : err.message
                );
              });
          })
            .then(() => {
              Modal.success({
                title: "สำเร็จ",
                content: "บันทึกเรียบร้อย",
                okText: "ปิด",
                onOk() {
                  history.goBack();
                },
              });
            })
            .catch((reason) => {
              Modal.error({
                title: "ผิดพลาด",
                content: reason,
                okText: "ปิด",
              });
            });
        },
      });
    });
  };

  const handleRemoveDesktop = async (e) => {
    setFileListDesktop([]);
    let isDelete = await onRemoveUpload(e, ...fileDelete);
    setFileDelete(isDelete);
  };

  const handleRemoveMobile = async (e) => {
    setFileListMobile([]);
    let isDelete = await onRemoveUpload(e, ...fileDelete);
    setFileDelete(isDelete);
  };

  const handleUploadDesktop = async (e) => {
    let isFile = await onUpload(e, 2000, 360);
    if (isFile) {
      setFileListDesktop(isFile);
    }
  };

  const handleUploadMobile = async (e) => {
    let isFile = await onUpload(e, 375, 150);
    if (isFile) {
      setFileListMobile(isFile);
    }
  };

  const loadContent = async () => {
    await axios({
      method: "get",
      baseURL: URL_API,
      url: "/manage-website/home/banner/" + match.params.id,
    })
      .then((res) => {
        console.log(res);
        let data = res.data?.data;
        console.log(data);
        let { start_date, end_date, loadDesktopImg, loadMobileImg } = data;

        for (let i in data.files) {
          if (data.files[i].document_type == "34") {
            loadDesktopImg = [
              {
                uid: data.files[i].id,
                status: "done",
                name: data.files[i].file_name,
                url: data.files[i].azure_url,
              },
            ];
            setFileListDesktop(loadDesktopImg);
          } else if (data.files[i].document_type == "35") {
            loadMobileImg = [
              {
                uid: data.files[i].id,
                status: "done",
                name: data.files[i].file_name,
                url: data.files[i].azure_url,
              },
            ];
            setFileListMobile(loadMobileImg);
          }
        }

        form.setFieldsValue({
          ...data,
          start_date: start_date == null ? null : moment(start_date),
          end_date: end_date == null ? null : moment(end_date),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (match.params.id !== "add") {
      loadContent(match.params.id);
    }
  }, [match.params.id]);

  const { getFieldDecorator } = form;

  return (
    <Panel>
      <PanelHeader></PanelHeader>
      <PanelBody>
        <Form layout="vertical">
          <Row gutter={24}>
            <Col md={12}>
              {fileListDesktop.length != 0 ? (
                <Row>
                  <div style={DivStyles}>
                    <img
                      src={fileListDesktop[0].url}
                      alt="desktop_img"
                      style={ImgStyles}
                    />
                  </div>
                </Row>
              ) : (
                ""
              )}
            </Col>
            <Col md={12}>
              {fileListMobile.length != 0 ? (
                <div style={DivStyles}>
                  <img
                    src={fileListMobile[0].url}
                    alt="mobile_img"
                    style={ImgStyles}
                  />
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item
                label="Desktop Size : 2000 x 360 px"
                name="desktop_img"
              >
                {getFieldDecorator("desktop_img", {
                  initialValue: null,
                })(
                  <Upload.Dragger
                    accept="image/*"
                    multiple={false}
                    fileList={fileListDesktop || []}
                    customRequest={dummyRequest}
                    beforeUpload={beforeUploadImg}
                    onChange={handleUploadDesktop}
                    onRemove={handleRemoveDesktop}
                    listType="picture"
                  >
                    <AiOutlineUpload className="mr-3" />
                    เพิ่มรูปภาพ
                  </Upload.Dragger>
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Mobile Size : 375 x 150 px">
                {getFieldDecorator("mobile_img", {
                  initialValue: null,
                })(
                  <Upload.Dragger
                    accept="image/*"
                    multiple={false}
                    fileList={fileListMobile || []}
                    customRequest={dummyRequest}
                    beforeUpload={beforeUploadImg}
                    onChange={handleUploadMobile}
                    onRemove={handleRemoveMobile}
                    listType="picture"
                  >
                    <AiOutlineUpload className="mr-3" />
                    เพิ่มรูปภาพ
                  </Upload.Dragger>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Target Link">
                {getFieldDecorator("target_link", {
                  initialValue: "",
                  rules: [{ required: true, message: "กรุณาระบุ Target Link" }],
                })(<Input />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Auto Slide ( วินาที )">
                {getFieldDecorator("delay_slide", {
                  initialValue: 1,
                  rules: [
                    { required: true, message: "กรุณาระบุ Auto Slide (Delay)" },
                  ],
                })(<InputNumber className="w-100" step="1" min={1} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Start Date">
                {getFieldDecorator("start_date", {
                  initialValue: null,
                  rules: [{ required: true, message: "กรุณาระบุ Start Date" }],
                })(
                  <DatePicker
                    showTime
                    className="w-100"
                    format="DD/MM/YYYY HH:mm"
                  />
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="End Date">
                {getFieldDecorator("end_date", {
                  initialValue: null,
                  rules: [{ required: true, message: "กรุณาระบุ End Date" }],
                })(
                  <DatePicker
                    showTime
                    className="w-100"
                    format="DD/MM/YYYY HH:mm"
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12}>
              <Form.Item label="Target">
                {getFieldDecorator("target_tab", {
                  initialValue: "stay_tab",
                })(
                  <Radio.Group>
                    <Radio value={"stay_tab"}>Stay Tab</Radio>
                    <Radio value={"new_tab"}>New Tab</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={24}>
              <Button
                className="bg-nn border-nn text-white mr-3"
                onClick={() => {
                  history.goBack();
                }}
              >
                Cancel
              </Button>
              <Button type="primary" onClick={() => handleClickSubmit()}>
                {match.params.id !== "add" ? "Update" : "Save"}
              </Button>
            </Col>
          </Row>
        </Form>
      </PanelBody>
    </Panel>
  );
}

export default Form.create("home-banner")(BannerContent);
